module.exports = __webpack_public_path__ + "00c1bae8d76d726a20ba8f350690d37e.MP3";